import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-policychange-common-react';
import PCPAAddressPage from './pages/Address/AddressPage';
import PCPACoveragePage from './pages/Coverages/CoveragePage';
import PCPAVehiclePage from './pages/Vehicles/VehiclesPage';
import PCPAQuotePage from './pages/Quote/QuotePage';
import PAAdditionalInfoToPurchasePagePolChange from './pages/AdditionalInfoToPurchase/AdditionalInfoToPurchasePagePolChange';
import PCPADriverPage from '../ml-capability-policychange-common-react/pages/Drivers/DriversPagePolChange';
import PAAddressPagePolChange from '../ml-capability-policychange-common-react/pages/Address/AddressPagePolChange';
import PAAffiliationPagePolChange from '../ml-capability-policychange-common-react/pages/Affiliation/AffiliationPagePolChange';
import PABillingDetailsPagePolChange from '../ml-capability-policychange-common-react/pages/BillingDetails/BillingDetailsPagePolChange';
import PAHouseholdMembersPagePolChange from '../ml-capability-policychange-common-react/pages/PAHouseholdMembers/PAHouseholdMembersPagePolChange';
import PAVehiclesPagePolChange from '../ml-capability-policychange-common-react/pages/Vehicles/VehiclesPagePolChange'
import AdditionalPolicyInfoPolChange from '../ml-capability-policychange-common-react/pages/AdditionalPolicyInfo/AdditionalPolicyInfoPolChange';
import PAConfirmationPolChange from '../ml-capability-policychange-common-react/pages/Confirmation/ConfirmationPolChange';
import PADisclosurePagePolChange from '../ml-capability-policychange-common-react/pages/Disclosures/DisclosurePagePolChange';
import MLPAVeracityCheckPage from '../ml-capability-policychange-common-react/pages/MLPAVeracityCheck/MLPAVeracityCheckPage';
import PARentedTrailerCamperPolChange from '../ml-capability-policychange-common-react/pages/PARentedTrailerCamper/PARentedTrailerCamperPolChange';

setComponentMapOverrides(
    {
        PCPAAddressPage: { component: 'PCPAAddressPage' },
        PCPAVehiclePage: { component: 'PCPAVehiclePage' },
        PCPADriverPage: { component: 'PCPADriverPage' },
        PCPACoveragePage: { component: 'PCPACoveragePage' },
        PCPAQuotePage: { component: 'PCPAQuotePage' },
        PAAddressPagePolChange: { component: 'PAAddressPagePolChange' },
        PAAffiliationPagePolChange: { component: 'PAAffiliationPagePolChange' },
        PABillingDetailsPagePolChange: { component: 'PABillingDetailsPagePolChange' },
        PAHouseholdMembersPagePolChange: { component: 'PAHouseholdMembersPagePolChange' },
        PAVehiclesPagePolChange: {component: 'PAVehiclesPagePolChange'},
        AdditionalPolicyInfoPolChange: { component: 'AdditionalPolicyInfoPolChange' },
        PAConfirmationPolChange: { component: 'PAConfirmationPolChange' },
        PAAdditionalInfoToPurchasePagePolChange: { component: 'PAAdditionalInfoToPurchasePagePolChange' },
        PADisclosurePagePolChange: { component: 'PADisclosurePagePolChange' },
        MLPAVeracityCheckPage: { component: 'MLPAVeracityCheckPage' },
        PARentedTrailerCamperPolChange: { component: 'PARentedTrailerCamperPolChange'}
    },
    {
        PCPAAddressPage,
        PCPAVehiclePage,
        PCPADriverPage,
        PCPACoveragePage,
        PCPAQuotePage,
        PAAddressPagePolChange,
        PAAffiliationPagePolChange,
        PABillingDetailsPagePolChange,
        PAHouseholdMembersPagePolChange,
        PAVehiclesPagePolChange,
        AdditionalPolicyInfoPolChange,
        PAConfirmationPolChange,
        PAAdditionalInfoToPurchasePagePolChange,
        PADisclosurePagePolChange,
        MLPAVeracityCheckPage,
        PARentedTrailerCamperPolChange
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PAPolicyChangeMessages } from './PAPolicyChange.messages';
export { default as PAPolicyChangeWizard } from './PAPolicyChangeWizard';
